import { faIdCard } from '@fortawesome/pro-light-svg-icons'

import { TeamModel } from '@domain-group/realhub-backend-api-types'

import { generateUrls } from '@hooks/useTeam'

const generateTabBarItems = (team: TeamModel) => {
  const urls = generateUrls(team)
  const { editTeamUrl } = urls

  return [
    {
      icon: faIdCard,
      href: editTeamUrl,
      key: 'details',
      title: team?.title || 'Team Details',
    },
  ]
}

export default generateTabBarItems
